module.exports = __webpack_public_path__ + "static/media/18ECA26.c8360296.jpg";